import React, { useState, useEffect } from "react";
import { getTestSeriesList, testAdd } from "../../api/TestService";
import MocklHeader from "./MockHeader";
import Nav from "../master/NavBar";
import { ToastMain, SweetAlertShow } from "../master/Master";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { courseList } from "../../api/Courses";
import { getBatchList } from "../../api/BatchService";
import { getSessions } from "../../api/SessionsService";

const CreateMockTest = () => {
  const [loading, setLoading] = useState(false);
  const [courses, setCourses] = useState([]);
  const [batch, setBatch] = useState([]);
  const location = useLocation();
  const [selectedSubjectIds, setSelectedSubjectIds] = useState([]);
  const [marksList, setMarksList] = useState({});
  const [selectedCourseId, setSelectedCourseId] = useState("");
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [typeTest, setTypeTest] = useState("");
  const [totalMarks, setTotalMarks] = useState(0);
  const [Data, setData] = useState([]);
  const [error, setError] = useState("");
  const [selectedSession, setSelectedSession] = useState("");
  const [subjectDetails, setSubjectDetails] = useState([]);
  const [scheduleData, setScheduleData] = useState([]);
  const navigate = useNavigate();
  const [enableTimeTable, setEnableTimeTable] = useState(false);
  const [selectedBatches, setSelectedBatches] = useState([]);

  // ✅ Filtered subjects based on selected checkboxes
  // ✅ Update subjectDetails dynamically when checkboxes change
  useEffect(() => {
    const filtered = selectedSubjects
      .filter((sub) => selectedSubjectIds.includes(sub.id))
      .map((sub) => ({
        subject_name: sub.name,
        subject_id: sub.id,
        date: "",
        start_time: "",
        end_time: "",
      }));

    setSubjectDetails(filtered);
    setScheduleData(filtered);
  }, [selectedSubjectIds, selectedSubjects]);

  const handleScheduleChange = (index, field, value) => {
    const updated = [...scheduleData];
    updated[index][field] = value;
    setScheduleData(updated);
  };

  const getSession = async () => {
    setLoading(true);
    try {
      const response = await getSessions();
      if (response?.data?.status) {
        const activeSession = response?.data?.data?.find(
          (s) => s.status === "1",
        );
        if (activeSession) setSelectedSession(activeSession.id);
      } else {
        // ToastMain.fire({
        //   icon: "info",
        //   title: response?.data?.message || "Something went wrong!",
        // });

        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      // ToastMain.fire({
      //   icon: "error",
      //   title: error?.response?.data?.message || "Something went wrong!",
      // });

      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSession();
  }, []);

  const handleCheckboxChange = (subjectId) => {
    setSelectedSubjectIds((prevSelected) =>
      prevSelected.includes(subjectId)
        ? prevSelected.filter((id) => id !== subjectId)
        : [...prevSelected, subjectId],
    );
  };

  useEffect(() => {
    const selectedCourse = courses.find(
      (course) => course.id === parseInt(selectedCourseId),
    );
    if (selectedCourse) {
      setSelectedSubjects(selectedCourse.subjects_list);
    } else {
      setSelectedSubjects([]);
    }
  }, [selectedCourseId, courses]);

  const handleMarksChange = (subjectId, value) => {
    setMarksList((prev) => ({
      ...prev,
      [subjectId]: value,
    }));
  };

  useEffect(() => {
    const total = Object.values(marksList)
      .map((m) => Number(m) || 0)
      .reduce((sum, val) => sum + val, 0);
    setTotalMarks(total);
  }, [marksList]);

  const createTest = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData(e.target);
      const subjectSchedule = scheduleData.map((item) => ({
        subject_id: item.subject_id,
        subject_name: item?.subject_name,
        date: item.date,
        start_time: item.start_time,
        end_time: item.end_time,
      }));

      // ✅ Add to form data as JSON
      // formData.append("subject_schedule", JSON.stringify(subjectSchedule));
      if (enableTimeTable) {
        formData.append("subject_schedule", JSON.stringify(subjectSchedule));
      }

      console.log("📦 Final FormData before submit:");
      for (let pair of formData.entries()) {
        console.log(pair[0], pair[1]);
      }

      const response = await testAdd(formData);

      if (response?.data?.status) {
        ToastMain.fire({
          icon: "success",
          title: "Created Successfully!",
        }).then(() => {
          navigate("/tests/view");
        });
      } else {
        if (response?.data?.errors) setError(response?.data?.errors);
        // ToastMain.fire({
        //   icon: "info",
        //   title: response?.data?.message || "Something went wrong!",
        // });

        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      if (error?.response?.data?.errors)
        setError(error?.response?.data?.errors);
      // ToastMain.fire({
      //   icon: "error",
      //   title:
      //     error?.response?.data?.message ||
      //     error?.response?.message ||
      //     "Something went wrong!",
      // });

      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const courseFetch = async () => {
    setLoading(true);
    try {
      const response = await courseList();
      if (response.data.status) {
        setCourses(response?.data?.data);
      } else {
        // ToastMain.fire({
        //   icon: "info",
        //   title: response?.data?.message || "Something went wrong!",
        // });

        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      // ToastMain.fire({
      //   icon: "error",
      //   title: error?.response?.data?.message || "Something went wrong!",
      // });

      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const batchFetch = async (id) => {
    setLoading(true);
    let addUrl = `&session_id=${selectedSession}&course_id=${id}`;
    try {
      const response = await getBatchList(addUrl);
      if (response.data && response.data.batches) {
        setBatch(response.data.batches);
      } else {
        // ToastMain.fire({
        //   icon: "info",
        //   title: response?.data?.message || "Something went wrong!",
        // });

        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      // ToastMain.fire({
      //   icon: "error",
      //   title: error?.response?.data?.message || "Something went wrong!",
      // });

      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const fetchSeriesList = async () => {
    setLoading(true);
    try {
      const response = await getTestSeriesList();
      if (response.data.status) {
        setData(response?.data?.data);
      }
    } catch (error) {
      // ToastMain.fire({
      //   icon: "error",
      //   title: error?.response?.data?.message || "Something went wrong!",
      // });

      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    courseFetch();
    fetchSeriesList();
  }, []);

  return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            {[...Array(6)].map((_, i) => (
              <div className="sk-chase-dot" key={i} />
            ))}
          </div>
        </div>
      )}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <MocklHeader />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper ">
              <div className="container-fluid mt-2">
                <div className="row custom-scroll-pane">
                  <div className="col-md-12 right-pane">
                    <div className="card">
                      <div className="card-header d-flex align-items-center justify-content-between">
                        <h5 className="m-0">New Test</h5>
                        <button
                          className="btn btn-outline-primary "
                          onClick={(e) => {
                            navigate(-1);
                          }}
                        >
                          <i className="bi bi-arrow-left-circle me-1"></i>Back
                        </button>
                      </div>

                      <div className="card-body">
                        <form onSubmit={createTest}>
                          <div className="row">
                            {/* Test Type */}
                            <div className="col-md-6 form-floating form-floating-outline mb-3">
                              <select
                                name="test_type"
                                className="form-control"
                                onChange={(e) => setTypeTest(e.target.value)}
                                value={typeTest}
                              >
                                <option value="">Test Type</option>
                                <option value="series">Series</option>
                                <option value="notseries">
                                  Without Series
                                </option>
                              </select>
                              <label>Test Type</label>
                              <span className="text-danger">
                                {error?.test_type || ""}
                              </span>
                            </div>

                            {typeTest === "series" && (
                              <div className="col-md-6 form-floating form-floating-outline mb-3">
                                <select
                                  name="parent_id"
                                  className="form-control"
                                >
                                  <option value="">Select Series</option>
                                  {Data?.data?.map((ser) => (
                                    <option key={ser.id} value={ser.id}>
                                      {ser.title}:(
                                      {ser?.type == 0
                                        ? "test"
                                        : ser?.type == 1
                                          ? "exam"
                                          : ""}
                                      )
                                    </option>
                                  ))}
                                </select>
                                <label>Select Series</label>
                                <span className="text-danger">
                                  {error?.parent_id || ""}
                                </span>
                              </div>
                            )}

                            {/* Course Selection */}
                            <div className="col-md-6 form-floating form-floating-outline">
                              <select
                                name="course_id"
                                className="form-control"
                                onChange={(e) => {
                                  setSelectedCourseId(e.target.value);
                                  batchFetch(e.target.value);
                                }}
                                value={selectedCourseId}
                              >
                                <option value="">Select Course</option>
                                {courses?.map((course, index) => (
                                  <option key={index} value={course.id}>
                                    {course?.title}
                                  </option>
                                ))}
                              </select>
                              <label>Select Course</label>
                              <span className="text-danger">
                                {error?.course_id || ""}
                              </span>
                            </div>

                            {/* Batch Selection */}
                            <div className="col-md-6 form-floating form-floating-outline">
                              <div
                                className="border rounded p-2"
                                style={{
                                  maxHeight: "200px",
                                  overflowY: "auto",
                                }}
                              >
                                {batch?.map((batchItem, i) => {
                                  const courseTitle =
                                    batchItem?.course?.title || "";
                                  const shortCourseTitle =
                                    courseTitle.length > 20
                                      ? courseTitle.substring(0, 20) + "..."
                                      : courseTitle;

                                  return (
                                    <div key={i} className="form-check mb-1">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value={batchItem?.id}
                                        id={`batch_${i}`}
                                        name="batch_id[]"
                                        onChange={(e) => {
                                          const value = batchItem?.id;
                                          let updated = [...selectedBatches];

                                          if (e.target.checked) {
                                            updated.push(value);
                                          } else {
                                            updated = updated.filter(
                                              (v) => v !== value,
                                            );
                                          }

                                          setSelectedBatches(updated);
                                        }}
                                      />

                                      <label
                                        className="form-check-label"
                                        htmlFor={`batch_${i}`}
                                      >
                                        {batchItem?.title} ({shortCourseTitle})
                                      </label>
                                      {/* <label className='mb-2 fw-bold'>Select Batch</label> */}
                                    </div>
                                  );
                                })}
                              </div>

                              <span className="text-danger">
                                {error?.batch_id || ""}
                              </span>
                            </div>

                            {/* Subject Selection */}
                            <div className="col-md-12 mt-3">
                              <label className="form-label fw-bold">
                                Select Subjects
                              </label>
                              <div className="row">
                                {selectedSubjects?.map((subject, index) => (
                                  <div
                                    className="col-lg-3 col-md-4 col-sm-6 mb-2"
                                    key={index}
                                  >
                                    <div className="form-check">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value={subject.id}
                                        name="subjects[]"
                                        id={`subject${index}`}
                                        onChange={() =>
                                          handleCheckboxChange(subject.id)
                                        }
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor={`subject${index}`}
                                      >
                                        {subject.name}
                                      </label>
                                      {selectedSubjectIds.includes(
                                        subject.id,
                                      ) && (
                                        <div className="form-floating form-floating-outline mt-2">
                                          <input
                                            type="number"
                                            className="form-control"
                                            name="subjects_marks[]"
                                            onChange={(e) =>
                                              handleMarksChange(
                                                subject.id,
                                                e.target.value,
                                              )
                                            }
                                            value={marksList[subject.id] || ""}
                                          />
                                          <label>Marks</label>
                                          <span className="text-danger">
                                            {error?.subjects_marks || ""}
                                          </span>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>

                            {/* Title */}
                            <div className="col-md-6 form-floating form-floating-outline mb-4 mt-4">
                              <input
                                type="text"
                                name="title"
                                className="form-control input-capitalize"
                              />
                              <label>Title</label>
                              <span className="text-danger">
                                {error?.title || ""}
                              </span>
                            </div>

                            <div className="col-md-6 form-floating form-floating-outline">
                              <input
                                type="number"
                                name="total_marks"
                                className="form-control"
                                value={totalMarks}
                                readOnly
                              />
                              <label>Total Marks</label>
                              <span className="text-danger">
                                {error?.total_marks || ""}
                              </span>
                            </div>

                            <div className="col-md-6 form-floating form-floating-outline">
                              <input
                                type="date"
                                name="date"
                                className="form-control"
                              />
                              <label>Date</label>
                              <span className="text-danger">
                                {error?.date || ""}
                              </span>
                            </div>

                            <div className="d-flex">
                              <button
                                type="button"
                                className={`btn btn-sm mt-2 ${enableTimeTable ? "btn-success" : "btn-secondary"}`}
                                onClick={() =>
                                  setEnableTimeTable(!enableTimeTable)
                                }
                              >
                                {enableTimeTable
                                  ? "Time Table Enabled"
                                  : "Create Time Table"}
                              </button>
                            </div>

                            {enableTimeTable && (
                              <table className="table table-bordered table-sm align-middle text-center mt-3 mb-3">
                                <thead className="table-light">
                                  <tr>
                                    <th>Subject</th>
                                    <th>Date</th>
                                    <th>Start Time</th>
                                    <th>End Time</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {subjectDetails.map((item, index) => (
                                    <tr key={index}>
                                      <td>{item.subject_name}</td>

                                      <td>
                                        <input
                                          type="date"
                                          className="form-control form-control-sm"
                                          value={
                                            scheduleData[index]?.date || ""
                                          }
                                          onChange={(e) =>
                                            handleScheduleChange(
                                              index,
                                              "date",
                                              e.target.value,
                                            )
                                          }
                                        />
                                      </td>
                                      <td>
                                        <input
                                          type="time"
                                          className="form-control form-control-sm"
                                          value={
                                            scheduleData[index]?.start_time ||
                                            ""
                                          }
                                          onChange={(e) =>
                                            handleScheduleChange(
                                              index,
                                              "start_time",
                                              e.target.value,
                                            )
                                          }
                                        />
                                      </td>
                                      <td>
                                        <input
                                          type="time"
                                          className="form-control form-control-sm"
                                          value={
                                            scheduleData[index]?.end_time || ""
                                          }
                                          onChange={(e) =>
                                            handleScheduleChange(
                                              index,
                                              "end_time",
                                              e.target.value,
                                            )
                                          }
                                        />
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            )}
                          </div>

                          <button
                            type="submit"
                            className="btn btn-primary px-5 mt-3"
                            disabled={loading}
                          >
                            {loading ? (
                              <>
                                <span
                                  className="spinner-border spinner-border-sm me-2"
                                  role="status"
                                ></span>
                                Submitting...
                              </>
                            ) : (
                              "Submit"
                            )}
                          </button>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateMockTest;
